
import { Button, TextField, IconButton, Select, MenuItem, Box } from '@material-ui/core';
import { Delete } from '@material-ui/icons'
import React, { Fragment } from 'react';
import { Teacher } from '../../../interfaces/examiner/Teacher';
import DataTable from 'react-data-table-component';
import request from '../../../api';
import FileSaver from 'file-saver';

interface Props {
  onClickTeacher:(teacherId:string)=>void
}

interface State {
  data:Teacher[]|null
  totalRows:number
  rowsPerPage:number
  page:number
  sortColumn:string
  sortOrder:'asc'|'desc',
  searchQuery:string
  canUpload: boolean
  uploadMessage: string
  statusFilter:'ACTIVE'|'PENDING'|'BLOCKED'|'REJECTED'|'REQUIRES_VERIFICATION'|'ALL'
  locationFilter:'ALL'|'UK'|'Overseas'|'Test'
  blockedTeachersSearchQuery: string
  blockedTeachers: Teacher[]
  blockedTeachersTotalRows: number
  groupByDomain: boolean
}

export default class ExaminerTeacherList extends React.Component<Props, State> {

  constructor(props:Props) {

    super(props)

    this.state = {
      canUpload:true,
      uploadMessage:'',
      data:[],
      totalRows:0,
      rowsPerPage:10,
      page:1,
      sortColumn:'timestamp',
      sortOrder:'desc',
      searchQuery:'',
      statusFilter:'ACTIVE',
      locationFilter:'ALL',
      blockedTeachersSearchQuery: '',
      blockedTeachers: [],
      blockedTeachersTotalRows: 0,
      groupByDomain: false
    }
  }

  columns: any[] = [
    // {
    //     name: 'Timestamp',
    //     selector: 'timestamp',
    //     sortable: true,
    //     cell: (teacher: Teacher) => new Date(teacher.timestamp).toLocaleDateString()
    // },
    {
      name: 'Name',
      selector: 'name',
      sortable: true
    },
    // {
    //     name: 'Email',
    //     selector: 'email',
    //     sortable: true
    // },
    {
      name: 'School Code',
      selector: 'schoolCode',
      sortable: true
    },
    {
      name: 'School',
      selector: 'school',
      sortable: true,
      cell: (teacher: Teacher) => (
        <Fragment>
          {teacher.school}
          {teacher.emailDomainFlagged && (
            <span style={{ color: '#ff9800', marginLeft: '8px', fontSize: '12px' }}>
                            ⚠️ Duplicate domain
                        </span>
          )}
        </Fragment>
      )
    },
    {
      name: 'Email Domain',
      selector: 'email',
      sortable: false,
      cell: (teacher: Teacher) => {
        const emailDomain = teacher.email?.split('@')[1] || ''
        return emailDomain
      }
    },
    {
      name: 'Phone Number',
      selector: 'phoneNumber',
      sortable: true
    },
    {
      name: 'Location',
      selector: 'location',
      sortable: true
    },
    {
      name: 'Default Student Password',
      selector: 'defaultPassword',
      sortable: false
    },
    // {
    //     name: 'Consent1',
    //     selector: 'consent1',
    //     sortable: true
    // },
    // {
    //     name: 'Consent2',
    //     selector: 'consent2',
    //     sortable: true
    // },
    // {
    //     name: 'Emailed',
    //     selector: 'emailed',
    //     sortable: true
    // }
  ]

  getGroupedData = (): Teacher[] => {
    if (!this.state.groupByDomain || !this.state.data) {
      return this.state.data || []
    }

    // Group teachers by email domain
    const domainMap = new Map<string, Teacher[]>()

    this.state.data.forEach(teacher => {
      const domain = teacher.email?.split('@')[1] || 'unknown'
      if (!domainMap.has(domain)) {
        domainMap.set(domain, [])
      }
      domainMap.get(domain)!.push(teacher)
    })

    // Sort domains by number of teachers (duplicates first), then alphabetically
    const sortedDomains = Array.from(domainMap.entries()).sort((a, b) => {
      const aCount = a[1].length
      const bCount = b[1].length
      if (aCount !== bCount) {
        return bCount - aCount // More duplicates first
      }
      return a[0].localeCompare(b[0])
    })

    // Flatten back to array, but grouped
    const grouped: Teacher[] = []
    sortedDomains.forEach(([domain, teachers]) => {
      teachers.forEach(teacher => {
        grouped.push(teacher)
      })
    })

    return grouped
  }

  render() {

    let { totalRows, canUpload, uploadMessage, statusFilter, locationFilter } = this.state
    const displayData = this.getGroupedData()

    if(displayData === null) {
      return <div>Loading...</div>
    }

    return (
      <Fragment>
        <Button variant="outlined" color={statusFilter==='ACTIVE' ? 'primary' : 'default'} onClick={() => this.setStatusFilter('ACTIVE')}>
          Active
        </Button>
        <Button variant="outlined" color={statusFilter==='PENDING' ? 'primary' : 'default'} onClick={() => this.setStatusFilter('PENDING')} style={{ marginLeft: 8 }}>
          Pending
        </Button>
        <Button variant="outlined" color={statusFilter==='BLOCKED' ? 'primary' : 'default'} onClick={() => this.setStatusFilter('BLOCKED')} style={{ marginLeft: 8 }}>
          Blocked
        </Button>
        <Button variant="outlined" color={statusFilter==='REJECTED' ? 'primary' : 'default'} onClick={() => this.setStatusFilter('REJECTED')} style={{ marginLeft: 8 }}>
          Rejected
        </Button>
        <Button variant="outlined" color={statusFilter==='REQUIRES_VERIFICATION' ? 'primary' : 'default'} onClick={() => this.setStatusFilter('REQUIRES_VERIFICATION')} style={{ marginLeft: 8 }}>
          Requires verification
        </Button>
        <Button variant="outlined" color={statusFilter==='ALL' ? 'primary' : 'default'} onClick={() => this.setStatusFilter('ALL')} style={{ marginLeft: 8 }}>
          All
        </Button>
        <br/>
        <br/>
        <Button disabled={!canUpload} variant="outlined" color="primary" onClick={this.handleImportCSV} style={{ marginBottom: 8 }}>
          Import CSV
        </Button>
        <Button color="primary" variant="outlined" onClick={this.downloadPendingTeachers} style={{ marginLeft: 8, marginBottom: 8 }}>
          Download pending teachers
        </Button>
        <Button color="primary" variant="outlined" onClick={this.downloadActiveTeachers} style={{ marginLeft: 8, marginBottom: 8 }}>
          Download active teachers
        </Button>
        <Button color="primary" variant="outlined" onClick={this.downloadTeachers} style={{ marginLeft: 8, marginBottom: 8 }}>
          Download teacher list with consent to contact
        </Button>
        <Button color="primary" variant="outlined" onClick={this.downloadTeachersAll} style={{ marginLeft: 8, marginBottom: 8 }}>
          Download teacher list (all)
        </Button>
        {uploadMessage ? <p> {uploadMessage} </p> : <br/>}
        {statusFilter === 'BLOCKED' && (
          <Fragment>
            <br />
            <Button
              color="primary"
              variant="outlined"
              onClick={() => this.handleImportBlockedTeachers('replace')}
              style={{ marginRight: 8 }}
            >
              Upload blocked teachers CSV (Replace)
            </Button>
            <Button
              color="primary"
              variant="outlined"
              onClick={() => this.handleImportBlockedTeachers('add')}
            >
              Upload blocked teachers CSV (Add)
            </Button>
            <br />
            <br />
          </Fragment>
        )}
        <Box mt={2}>
          Filter by location:
          <Select margin="dense"
                  id="locationFilter" label="Location"
                  value={locationFilter}
                  displayEmpty
                  onChange={(e) => this.handleLocationFilterChange(e)}
                  style={{ marginLeft: 10 }}>
            <MenuItem value={'ALL'}>All</MenuItem>
            <MenuItem value={'UK'}>UK</MenuItem>
            <MenuItem value={'Overseas'}>Overseas</MenuItem>
            <MenuItem value={'Test'}>Test</MenuItem>
          </Select>
        </Box>
        <TextField margin="dense"
                   id="searchQuery" label="Search..."
                   fullWidth defaultValue=""
                   onChange={(e) => this.handleFieldChange(e.target.value)}
                   style={{ marginTop: 0 }}
        />
        {statusFilter === 'BLOCKED' && (
          <Fragment>
            <br />
            <strong>Blocked Teachers ({this.state.blockedTeachersTotalRows}):</strong>
            {this.state.blockedTeachersTotalRows > 0 ? (
              <Fragment>
                <br />
                <br />
                <TextField
                  margin="dense"
                  id="blockedTeachersSearch"
                  label="Search blocked teachers..."
                  fullWidth
                  value={this.state.blockedTeachersSearchQuery}
                  onChange={(e) => this.handleBlockedTeachersSearchChange(e.target.value)}
                  style={{ marginBottom: 16 }}
                />
                <DataTable
                  columns={[
                    {
                      name: 'Name',
                      selector: 'name',
                      sortable: true,
                    },
                    {
                      name: 'School Code',
                      selector: 'schoolCode',
                      sortable: true,
                    },
                    {
                      name: 'School',
                      selector: 'school',
                      sortable: true,
                    },
                    {
                      name: 'Email',
                      selector: 'email',
                      sortable: true,
                    },
                    {
                      name: 'Actions',
                      cell: (row: Teacher) => (
                        <IconButton
                          size="small"
                          onClick={() => this.handleRemoveBlockedTeacher(row.schoolCode)}
                          color="secondary"
                        >
                          <Delete fontSize="small" />
                        </IconButton>
                      ),
                      ignoreRowClick: true,
                      allowOverflow: true,
                      button: true,
                      width: '100px',
                    }
                  ]}
                  data={this.state.blockedTeachers}
                  pagination
                  paginationServer
                  paginationTotalRows={this.state.blockedTeachersTotalRows}
                  paginationRowsPerPageOptions={[10, 25, 50, 100]}
                  onChangeRowsPerPage={this.handleBlockedTeachersChangeRowsPerPage}
                  onChangePage={this.handleBlockedTeachersChangePage}
                  noHeader
                  dense
                />
              </Fragment>
            ) : (
              <p style={{ color: '#999' }}>No blocked teachers. Upload a CSV file with 'schoolCode' column to block teachers.</p>
            )}
            <br />
            <br />
          </Fragment>
        )}
        {this.state.groupByDomain && statusFilter === 'PENDING' && (
          <div style={{ marginBottom: '16px', padding: '12px', backgroundColor: '#fff3cd', borderRadius: '4px' }}>
            <strong>Grouped by Email Domain:</strong> Teachers with the same email domain are shown together.
            Domains with multiple teachers appear first.
          </div>
        )}
        <DataTable
          dense
          columns={this.columns}
          data={displayData}
          pagination={!this.state.groupByDomain}
          paginationServer={!this.state.groupByDomain}
          paginationTotalRows={this.state.groupByDomain ? displayData.length : totalRows}
          paginationRowsPerPageOptions = {[10,25,50,100,500]}
          sortServer={!this.state.groupByDomain}
          onSort={this.state.groupByDomain ? undefined : this.handleSort}
          onChangeRowsPerPage={this.handleChangeRowsPerPage}
          onChangePage={this.handleChangePage}
          noHeader
          highlightOnHover={true}
          pointerOnHover={true}
          onRowClicked={this.onRowClicked}
        />
      </Fragment>
    )
  }

  componentDidMount() {
    this.reload()
  }

  private async reload() {

    let { page, rowsPerPage, sortColumn, sortOrder, searchQuery, statusFilter, locationFilter } = this.state

    let { teachers, total } = await (
      await request(`/api/examiner/teachers?offset=${(page - 1) * rowsPerPage}&limit=${rowsPerPage}&sortBy=${sortColumn}&order=${sortOrder}&searchQuery=${searchQuery}&statusFilter=${statusFilter}&locationFilter=${locationFilter}`)
    ).json()

    this.setState(prevState => ({ ...prevState, data: teachers, totalRows: total }))
  }

  handleChangeRowsPerPage = async (rowsPerPage:number) => {
    await this.setState(prevState => ({ ...prevState, rowsPerPage }))
    this.reload()
  }

  handleChangePage = async (page:number) => {
    await this.setState(prevState => ({ ...prevState, page }))
    this.reload()
  }

  handleSort = async (column:any, sortDirection:any) => {
    await this.setState(prevState => ({ ...prevState, sortColumn: column.selector, sortOrder: sortDirection }))
    this.reload()
  }

  handleImportCSV = async () => {
    await this.setState(prevState => ({ ...prevState, canUpload: false, uploadMessage:'' }))

    let input = document.createElement('input')
    input.type = 'file'

    input.onchange = async (e:any) => {
      var file = e.target.files[0]

      let uploadRes = await request('/api/examiner/teachers', {
        method: 'POST',
        body: file,
        headers: {
          'content-type': 'text/plain'
        }
      })
      let message = await uploadRes.text()
      await this.setState(prevState => ({ ...prevState, canUpload: true, uploadMessage: message }))
      this.reload()

    }

    input.click()



  }

  downloadTeachers = async () => {
    // await this.setState(prevState => ({ ...prevState, downloading: true}))
    let r = await request(`/api/examiner/teachers/downloadTeachers?examId=ALL&selection=CONTACT`)

    let results = await r.text()

    var blob = new Blob([results], { type: 'text/csv' })
    FileSaver.saveAs(blob, 'TeachersCanContact.csv')
    // await this.setState(prevState => ({ ...prevState, downloading: false}))
  }

  downloadTeachersAll = async () => {
    // await this.setState(prevState => ({ ...prevState, downloading: true}))
    let r = await request(`/api/examiner/teachers/downloadTeachers?examId=ALL&selection=ALL`)

    let results = await r.text()

    var blob = new Blob([results], { type: 'text/csv' })
    FileSaver.saveAs(blob, 'TeachersAll.csv')
    // await this.setState(prevState => ({ ...prevState, downloading: false}))
  }

  downloadPendingTeachers = async () => {
    let r = await request(`/api/examiner/teachers/downloadPendingTeachers?status=PENDING`)

    let results = await r.text()

    var blob = new Blob([results], { type: 'text/csv' })
    FileSaver.saveAs(blob, 'PendingTeachers.csv')
  }

  downloadActiveTeachers = async () => {
    let r = await request(`/api/examiner/teachers/downloadPendingTeachers?status=ACTIVE`)

    let results = await r.text()

    var blob = new Blob([results], { type: 'text/csv' })
    FileSaver.saveAs(blob, 'ActiveTeachers.csv')
  }

  handleDeleteTeacher = async (teacher:Teacher) => {
    await request('/api/examiner/teachers/' + teacher.id, { method: 'DELETE' })
    this.reload()
  }

  onRowClicked = async (row:any) =>{
    this.props.onClickTeacher(row.id)
  }

  handleFieldChange = async (searchQuery:string) => {
    await this.setState(prevState => ({ ...prevState, searchQuery }))
    this.reload()
  }

  handleLocationFilterChange = async (ev:any) => {
    await this.setState(prevState => ({ ...prevState, locationFilter: ev.target.value, page: 1 }))
    this.reload()
  }

  setStatusFilter = async (statusFilter:'ACTIVE'|'PENDING'|'BLOCKED'|'REJECTED'|'REQUIRES_VERIFICATION'|'ALL') => {
    await this.setState(prevState => ({ ...prevState, statusFilter }))
    this.reload()
    if (statusFilter === 'BLOCKED') {
      this.reloadBlockedTeachers()
    }
  }

  componentDidUpdate(prevProps: Props, prevState: State) {
    if (this.state.statusFilter === 'BLOCKED' && prevState.statusFilter !== 'BLOCKED') {
      this.reloadBlockedTeachers()
    }
  }

  private async reloadBlockedTeachers() {
    let { page, rowsPerPage, sortColumn, sortOrder, blockedTeachersSearchQuery } = this.state

    let { teachers, total } = await (
      await request(`/api/examiner/teachers/blocked?offset=${(page - 1) * rowsPerPage}&limit=${rowsPerPage}&sortBy=${sortColumn}&order=${sortOrder}&searchQuery=${encodeURIComponent(blockedTeachersSearchQuery || '')}`)
    ).json()

    this.setState(prevState => ({ ...prevState, blockedTeachers: teachers, blockedTeachersTotalRows: total }))
  }

  handleImportBlockedTeachers = async (mode: 'replace' | 'add') => {
    await this.setState(prevState => ({ ...prevState, canUpload: false, uploadMessage: '' }))

    let input = document.createElement('input')
    input.type = 'file'

    input.onchange = async (e: any) => {
      var file = e.target.files[0]

      let uploadRes = await request(`/api/examiner/teachers/blocked/upload?mode=${mode}`, {
        method: 'POST',
        body: file,
        headers: {
          'content-type': 'text/plain'
        }
      })
      let message = await uploadRes.text()
      await this.setState(prevState => ({ ...prevState, canUpload: true, uploadMessage: message }))
      this.reload()
      this.reloadBlockedTeachers()
    }

    input.click()
  }

  handleBlockedTeachersSearchChange = async (searchQuery: string) => {
    await this.setState(prevState => ({ ...prevState, blockedTeachersSearchQuery: searchQuery, page: 1 }))
    this.reloadBlockedTeachers()
  }

  handleBlockedTeachersChangeRowsPerPage = async (rowsPerPage: number) => {
    await this.setState(prevState => ({ ...prevState, rowsPerPage }))
    this.reloadBlockedTeachers()
  }

  handleBlockedTeachersChangePage = async (page: number) => {
    await this.setState(prevState => ({ ...prevState, page }))
    this.reloadBlockedTeachers()
  }

  handleRemoveBlockedTeacher = async (schoolCode: string) => {
    if (!window.confirm(`Are you sure you want to unblock teacher with school code ${schoolCode}?`)) {
      return
    }
    try {
      await request(`/api/examiner/teachers/blocked/${schoolCode}`, { method: 'DELETE' })
      this.reload()
      this.reloadBlockedTeachers()
    } catch (e) {
      alert('Failed to unblock teacher: ' + (e.message || 'Unknown error'))
    }
  }

}
